module.exports = __webpack_public_path__ + "static/media/caret_down.32b06707.svg";